/**
 * According to original cookie spec https://curl.se/rfc/cookie_spec.html:
 * "NAME=VALUE This string is a sequence of characters excluding semi-colon, comma and white space."
 * So any ";", "," and " " will be ommited.
 * @param str Key=Value pair potentially with forbidden characters.
 */
export const validateCookieString = (str) => str.replace(/[\s\,\;]/gi, '');
